import { type CTNBreadcrumbLevel } from '@ctn/ui/types/ctn-breadcrumb';

import { type TramiteEstadoContratacion } from '@/interfaces/model/user.interface';

export const getBreadcrumbTramite = (tramite: TramiteEstadoContratacion): CTNBreadcrumbLevel => ({
	label: tramite.tipoTramite.descripcion,
	url: `/${tramite.codigo}`,
});

export const getUrlTramite = (tramite?: TramiteEstadoContratacion) => `/${tramite?.codigo}`;
